import { useAuth } from '../../contexts/AuthContext'
import Modal from './Modal'

function SessionWarning() {
  const { sessionWarning, extendSession, dismissSessionWarning, logout } = useAuth()

  if (!sessionWarning) return null

  const handleExtendSession = async () => {
    try {
      await extendSession()
    } catch (error) {
      console.error('Failed to extend session:', error)
      // If extension fails, the auth context will handle logout
    }
  }

  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  if (sessionWarning.type === 'expired') {
    return (
      <Modal
        isOpen={true}
        onClose={() => {}}
        title="Session Expired"
        className="max-w-md"
      >
        <div className="text-center">
          <div className="text-yellow-600 text-4xl mb-4">⏰</div>
          <p className="text-gray-700 mb-6">
            {sessionWarning.message}
          </p>
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            Go to Login
          </button>
        </div>
      </Modal>
    )
  }

  return (
    <Modal
      isOpen={true}
      onClose={dismissSessionWarning}
      title="Session Expiring Soon"
      className="max-w-md"
    >
      <div className="text-center">
        <div className="text-yellow-600 text-4xl mb-4">⚠️</div>
        <p className="text-gray-700 mb-6">
          {sessionWarning.message}
        </p>
        <div className="flex space-x-3">
          <button
            onClick={handleExtendSession}
            className="flex-1 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
          >
            Extend Session
          </button>
          <button
            onClick={handleLogout}
            className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Logout
          </button>
        </div>
        <button
          onClick={dismissSessionWarning}
          className="mt-3 text-sm text-gray-500 hover:text-gray-700"
        >
          Dismiss (session will still expire)
        </button>
      </div>
    </Modal>
  )
}

export default SessionWarning